<script>
    import Button,{ Label } from "@smui/button";
    import { createEventDispatcher,onMount } from "svelte";
    import { writable } from "svelte/store";
    import API from "../../API/API";
    import AppStore from "../../AppStore";
    import CommentThread from "../../Models/CommentThread";
    import Vessel from "../../Models/Vessel";
    import ConfirmDialogView from "../ConfirmDialog/ConfirmDialogView.svelte";
    import CommentForm from "./Form.svelte";
    import VesselCommentsStore from "./Store";
    import ThreadSummaryView from "./ThreadSummaryView.svelte";
    import ThreadView from "./ThreadView.svelte";
    import ViewState from "./ViewState";
        
    export let vessel = writable(new Vessel()); // null;
    export let useThreads = [];
    export let scrollable = true;
    export let showAddThreadButton = true;

    export let confirmDialog = VesselCommentsStore.confirmDialog; //new ConfirmDialogData();
    let confirmDialogVisible = confirmDialog.visible;

    const dispatch = createEventDispatcher(); // viewStateChange

    let loaded = false;
    let threads = writable(useThreads);
    let lastUpdated = writable(Date.now());
    onMount(()=>{
        if (useThreads.length === 0) {
            console.log("vessel", $vessel);
            console.log("spire id", $vessel.spireId);
            API.get("comments/vessel/" + $vessel.spireId)
                .then((results)=>{
                    console.log("results", results);

                    let thrds = [];
                    for(let i = 0; i < results.threads.length; i++) {
                        let thr = new CommentThread(results.threads[i]);
                        thrds.push(thr);
                    }
                    $threads = thrds;

                    loaded = true; 
                    $lastUpdated = Date.now();
                })
                .catch((err)=>{
                    console.error(err);
                });
        }
        else {
            $threads = useThreads;
            loaded = true;
            $lastUpdated = Date.now();
        }
    });

    
    let viewState = ViewState.ALL;
    let viewThread = null;
        
    let startNewThread = () => { 
        viewState = ViewState.NEW; 
        dispatch("viewStateChange", {viewState});
    };
    let startViewThread = (thread) => { 
        viewState = ViewState.THREAD; 
        viewThread = thread; 
        dispatch("viewStateChange", {viewState});
    };
    let cancelAll = () => { 
        viewState = ViewState.ALL; 
        dispatch("viewStateChange", {viewState});
    };
    
</script>
<style>
    
    .vessel-notes-view.scrollable {
        padding-top:10px;
        border-top:1px solid #eee;
        margin-top:-2px;
        max-height:400px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .vessel-notes-view .no-threads {
        background-color: #eee;
    }

    .confirm-dialog {
        width:100%;
        height:100%;
        position:fixed;
        top:0;
        left:0;
        display:none;
    }
    .confirm-dialog.visible {
        display:block;
    }
    
</style>
<div class="vessel-notes-view" class:scrollable={scrollable}>
    
    {#if !loaded}
        Loading...
    {:else}
        {#if viewState === ViewState.ALL}
            {#if $threads.length === 0}
                <div class="msgbox mb-10 oa no-threads">No threads.</div>
            {:else}
                {#each $threads as thread (thread.id)}
                    <ThreadSummaryView thread={thread} on:click={() => { startViewThread(thread); }} />
                {/each}
            {/if}
            {#if showAddThreadButton}
                <Button on:click={startNewThread} fullwidth color="secondary" variant="unelevated" style='margin-top:0px;width:100%;'>
                    <Label>New Thread</Label>
                </Button>
            {/if}
        {:else if viewState === ViewState.THREAD}
            <ThreadView 
                vessel={vessel}
                thread={viewThread} 
                confirmDialog={confirmDialog}
                on:cancel={cancelAll} 
                on:delete={()=>{
                    for(let i = 0; i < $threads.length; i++) {
                        if ($threads[i] === viewThread) {
                            $threads.splice(i, 1);
                            break;
                        }
                    }
                    $threads = $threads;
                    AppStore.snackbar.start("Thread deleted successfully!", "success");
                    cancelAll();
                }} 
            />
        {:else if viewState === ViewState.NEW}
            <CommentForm 
                vessel={vessel} 
                on:cancel={cancelAll} 
                on:success={(e)=>{
                    $threads = [
                        ...$threads,
                        new CommentThread(e.detail.thread)
                    ];
                    viewState = ViewState.ALL;
                    dispatch("viewStateChange", {viewState});
                    $lastUpdated = Date.now();
                    AppStore.snackbar.start("Thread created successfully!", "success");
                }}
            />
        {/if}

    {/if}
        
</div>
<div class='confirm-dialog' class:visible={$confirmDialogVisible}>
    <ConfirmDialogView data={confirmDialog} />
</div>